import React from 'react'
import { Link } from 'gatsby'
import { Layout, Header, Intro, ItemTitle } from '../../../../components'

import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        slug={data.slug + '/design/'}
        site={data.site}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            Use these appearance classes to manipulate how an element is
            rendered.
          </p>
        </Intro>
        <ItemTitle>Border Radius</ItemTitle>

        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-border-radius--small</span>
                </div>
              </td>
              <td className="table__description">
                Gives element a border radius of 2px.
              </td>
            </tr>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-border-radius--medium</span>
                </div>
              </td>
              <td className="table__description">
                Gives element a border radius of 4px.
              </td>
            </tr>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-border-radius--large</span>
                </div>
              </td>
              <td className="table__description">
                Gives element a border radius of 8px.
              </td>
            </tr>
          </tbody>
        </table>
        <ItemTitle className="l-margin-top--xxlarge">Cursor</ItemTitle>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-cursor--pointer</span>
                </div>
              </td>
              <td className="table__description">
                Sets `cursor: pointer` to element, implying a click event.
              </td>
            </tr>
          </tbody>
        </table>
        <ItemTitle className="l-margin-top--xxlarge">List Style</ItemTitle>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-list-style--none</span>
                </div>
              </td>
              <td className="table__description">
                Sets `list-style-type: none` to element, removing all list
                bullets.
              </td>
            </tr>
          </tbody>
        </table>
        <ItemTitle className="l-margin-top--xxlarge">Reset</ItemTitle>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-reset--box</span>
                </div>
              </td>
              <td className="table__description">
                Resets the box model to `box-sizing: border-box`. Width and
                height properties will include content, padding and border.
              </td>
            </tr>
          </tbody>
        </table>

        <ItemTitle className="l-margin-top--xxlarge">Scroll</ItemTitle>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-scroll--none</span>
                </div>
              </td>
              <td className="table__description">
                Sets `overflow: none` on an element, removing all scrollbars.
              </td>
            </tr>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-scroll--vertical</span>
                </div>
              </td>
              <td className="table__description">
                Sets `overflow-y: auto` on an element, showing scrollbars
                whenever content overflows vertically.
              </td>
            </tr>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-scroll--horizontal</span>
                </div>
              </td>
              <td className="table__description">
                Sets `overflow-x: auto` on an element, showing scrollbars
                whenever content overflows horizontally.
              </td>
            </tr>
          </tbody>
        </table>
        <ItemTitle className="l-margin-top--xxlarge">Transform</ItemTitle>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-rotate--90</span>
                </div>
              </td>
              <td className="table__description">
                Rotates the element 90 degrees clockwise.
              </td>
            </tr>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-rotate--180</span>
                </div>
              </td>
              <td className="table__description">
                Rotates the element 180 degrees clockwise.
              </td>
            </tr>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-rotate--270</span>
                </div>
              </td>
              <td className="table__description">
                Rotates the element 270 degrees clockwise.
              </td>
            </tr>
          </tbody>
        </table>
        <ItemTitle className="l-margin-top--xxlarge">Visibility</ItemTitle>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-is-visible--[screen size]</span>
                </div>
              </td>
              <td className="table__description">
                Adds `display: block`, forcing element to appear visible at
                designated screen-size and below. <br />
                See{' '}
                <Link to={`/${data.site}/guidelines/grid-system/design/`}>
                  full list of breakpoints
                </Link>
                .
              </td>
            </tr>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">
                    u-is-visible-flex--[screen size]
                  </span>
                </div>
              </td>
              <td className="table__description">
                Adds `display: flex`, forcing element to appear visible at
                designated screen-size and below. <br />
                See{' '}
                <Link to={`/${data.site}/guidelines/grid-system/design/`}>
                  full list of breakpoints
                </Link>
                .
              </td>
            </tr>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-is-hidden--[screen size]</span>
                </div>
              </td>
              <td className="table__description">
                Adds `display: none`, forcing element to appear be hidden at
                desginated screen-size and below. <br />
                See{' '}
                <Link to={`/${data.site}/guidelines/grid-system/design/`}>
                  full list of breakpoints
                </Link>
                .
              </td>
            </tr>
          </tbody>
        </table>
        <ItemTitle className="l-margin-top--xxlarge">White Space</ItemTitle>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-white-space--nowrap</span>
                </div>
              </td>
              <td className="table__description">
                Sets `white-space: nowrap`, forcing text to never wrap onto the
                next line.
              </td>
            </tr>
            <tr>
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__code">u-white-space--normal</span>
                </div>
              </td>
              <td className="table__description">
                Sets `white-space: normal`, forcing text to wrap onto the next
                line whenever width is limited.
              </td>
            </tr>
          </tbody>
        </table>
      </Layout>
    </>
  )
}
